import {ExpenseReportDao} from '../../dao';
import {ErrorModel, ExpenseReportModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'GET_EXPENSE_REPORT_BY_ID';

export async function getExpenseReportById(userData: Record<string, string>, id: number) {
    try {
        const expenseReport = await ExpenseReportDao.getExpenseReportById(userData.userToken, id);

        const expenseReportParsed = ExpenseReportModel.parseExpenseReport(expenseReport);

        return expenseReportParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
